"use client";

import { useState } from "react";
import { I } from "@/components/kamibot-v2/discord";
import { Container, SectionHead } from "@/components/kamibot-v2/common";

const items = [
  {
    tag: "PRICING",
    q: "정말 무료인가요?",
    a: [
      "네, 카미봇의 핵심 기능은 무료로 쓸 수 있어요. 카드 등록도 회원가입도 없어요.",
      "서포터 멤버십은 선택이고요, 곳 들어올 프리미엄 플랜도 무료 기능을 줄이지 않는 방향으로 준비하고 있어요.",
    ],
  },
  {
    tag: "PERMISSIONS",
    q: "어떤 권한이 필요해요?",
    a: [
      "카미봇은 필요한 최소 권한만 요청해요. 메시지 보기·보내기, 슬래시 명령어 등록, 음성 채널 입장(음악·TTS용) 정도예요.",
      "관리자 권한은 요구하지 않고, 사용하지 않는 기능에 대한 권한은 비활성화해두셔도 돼요.",
    ],
  },
  {
    tag: "LANGUAGE",
    q: "한국어 외 다른 언어도 되나요?",
    a: [
      "UI는 한국어 중심이지만, TTS·AI·번역 같은 기능은 108개 언어를 지원해요. 일본어·영어 서버에서도 무리 없이 잘 작동해요.",
    ],
  },
  {
    tag: "PRIVACY",
    q: "메시지를 어디에 저장하나요?",
    a: [
      "명령을 처리하기 위해 필요한 순간에만 메시지를 읽고, 처리 후에는 저장하지 않아요. 자세한 내용은 개인정보 처리방침에서 확인하실 수 있어요.",
    ],
  },
  {
    tag: "SUPPORT",
    q: "도움이 필요하면 어디로 가요?",
    a: [
      "카미봇 지원 서버에 들어오시면 직접 답변드려요. 코드 한 줄 단위까지 같이 봐드릴 수 있는 작은 서비스라서, 너무 부담 갖지 마시고 와주세요.",
    ],
  },
  {
    tag: "PREMIUM",
    q: "프리미엄은 언제 나와요?",
    a: [
      "몇 달 안으로 준비 중이에요. 지금 무료로 쓰시는 기능은 그대로 두고, 더 긴 TTS·고급 모델·우선 지원 같은 \"더 든든한\" 자리에 들어올 예정이에요.",
      "정확한 시점은 멤버십 섹션 옆 알림 신청에 메일을 남겨두시면 가장 먼저 알려드려요.",
    ],
  },
];

export function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq">
      <Container>
        <SectionHead
          eyebrow="FAQ"
          title="자주 묻는 질문"
          sub="못 찾은 답이 있다면 카미봇 지원 서버에서 직접 여쭤보세요."
        />
        <div className="faq-list">
          {items.map((it, i) => (
            <div
              key={i}
              className="faq-item"
              data-open={open === i ? "true" : "false"}
            >
              <button
                type="button"
                className="faq-q"
                onClick={() => setOpen(open === i ? -1 : i)}
              >
                <span className="faq-tag">{it.tag}</span>
                <span>{it.q}</span>
                <I.chev className="chev" />
              </button>
              <div className="faq-a">
                <div>
                  {it.a.map((p, j) => (
                    <p key={j}>{p}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
